import { render, staticRenderFns } from "./AzPersonsReadOnly.vue?vue&type=template&id=4af09ed1"
import script from "./AzPersonsReadOnly.vue?vue&type=script&lang=js"
export * from "./AzPersonsReadOnly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports